import React, { useEffect } from 'react';
import { Form } from 'formik';
import Icon from 'components/Icon';
import HostedTableFooter from './HostedTableFooter';
import { Upload, Button, Checkbox, Row, Select } from 'antd';

const EditHostedTableForm = ({ values, touched, errors, setFieldValue, setTouched, setEditForm, showPreview, initialValues}) => {

  const uploadProps = {
    'data-testid': 'upload-csv-file',
    accept: ".csv, text/csv",
    onRemove: () => {
      setFieldValue("file", null);
    },
    beforeUpload: file => {
      setFieldValue("file", file);
      setTouched({ ...touched, "file": true });
      return false;
    },
    fileList: values.file ? [values.file] : [],
  };

  const delimiterList = [
    {
      value: ',',
      label: 'Comma (,)',
    },
    {
      value: ';',
      label: 'Semi Colon (;)',
    },
    {
      value: '|',
      label: 'Pipe (|)',
    },
  ];

  useEffect(() => {
    if (values.file) {
      setTouched({ ...touched, "file": true });
    }
  }, []);

  return (
    <Form className="k-form scroll-content-modal">
      <Row>
        <div className="rc-hosted-table-name-static">
          <span>TABLE NAME</span>
          <p>{values.tableName}</p>
        </div>
      </Row>
      <Row>
        <Checkbox
          checked={values.containsHeader}
          onChange={(e) => {
            setFieldValue("containsHeader", e.target.checked);
          }}
        >
          CSV Contains Headers
        </Checkbox>
      </Row>
      <Row>
        <Checkbox
          checked={values.truncateTableInExasol}
          onChange={(e) => {
            setFieldValue("truncateTableInExasol", e.target.checked);
          }}
        >
          Truncate Table
        </Checkbox>
      </Row>
      <Row>
        <label className='k-form-field'>
          <span className='input-label'>Separator Type</span>
          <div className='input-icon-wrapper'>
            <Select
              defaultValue={values.delimiter}
              value={values.delimiter}
              style={{ width: '100%' }}
              onChange={(value) => {
                setFieldValue("delimiter", value);
              }}
              options={delimiterList} />
          </div>
        </label>
      </Row>
      <Row>
        <label className="k-form-field ">
          <Upload {...uploadProps}>
            <Button className="required-field">
              <Icon type="upload" /> Select CSV File
            </Button>
          </Upload>
        </label>
        {touched?.file && typeof errors.file !== 'undefined' && <div className="form-error">{errors.file}</div>}
      </Row>
      <HostedTableFooter showPreview={() => showPreview(values.file, values.delimiter, values.containsHeader, values.tableName)} previewDisabled={values.file === null || typeof errors.file !== 'undefined'} isEdit={true} disabled={Object.keys(errors).length > 0} cancelForm={() => setEditForm('', false)} initialValues={initialValues} values={values} />
    </Form>
  );
};

export default EditHostedTableForm;
